import { all, fork } from 'redux-saga/effects';
import { pmpSagas } from './pmp/sagas';

export default function* () {
  yield all([
    fork(pmpSagas),
  ]);
}
